import i18next from 'i18next';

import es from './es';
import pt from './pt';
import en from './en';

i18next.addResourceBundle('es', 'processingModal', es);
i18next.addResourceBundle('en', 'processingModal', en);
i18next.addResourceBundle('pt', 'processingModal', pt);
